import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Stitch, UserPasswordAuthProviderClient, GoogleRedirectCredential, UserPasswordCredential, FacebookRedirectCredential } from 'mongodb-stitch-browser-sdk'


@Injectable({
  providedIn: 'root'
})

export class AuthService {

private user: Observable<firebase.User>;
private userDetails: firebase.User = null;
private token : string;
stichClient : any;

constructor(private _firebaseAuth: AngularFireAuth) { 
      this.user = _firebaseAuth.authState;
      this.setUpMongoDbStich();
      this.setUpAuthService();
  }

  setUpMongoDbStich(){
    this.stichClient = Stitch.defaultAppClient;
    
    
  }

  setUpAuthService(){
    this.user.subscribe(
      (user) => {
        if (user) {
          this.userDetails = user;
          console.log(this.userDetails);
        }
        else {
          this.userDetails = null;
        }
      }
    );
  }

  /**
   * Firebase Resgister User with email and Password
   */
 /* emailSignup(value){
    return new Promise<any>((resolve, reject) => {
      this._firebaseAuth.auth.createUserWithEmailAndPassword(value.email, value.password)
      .then(res => {
        this.catchTokenLocally();
        resolve(res);
      }, err => reject(err))
    });
  }*/


  emailSignup(value){

    const emailPassClient = Stitch.defaultAppClient.auth
      .getProviderClient(UserPasswordAuthProviderClient.factory);

      return new Promise<any>((resolve, reject) => {
        emailPassClient.registerWithEmail(value.email, value.password)
        .then(res => {
          console.log("Successfully sent account confirmation email!");
         // this.catchTokenLocally();
          resolve(res);
        }, err => {
          console.log("Error registering new user:", err);  
          reject(err);
        })
      });

     
  }



/*
  emailLogin(value) {
    return new Promise<any>((resolve, reject) => {
      this._firebaseAuth.auth.signInWithEmailAndPassword(value.email, value.password)
      .then(res => {
        this.catchTokenLocally();
        resolve(res);
      }, err => reject(err))
    });
  }*/

  emailLogin(value) {

    const credential = new UserPasswordCredential(value.email, value.password);
    
    return new Promise<any>((resolve, reject) => {
      Stitch.defaultAppClient.auth.loginWithCredential(credential)
      .then(res => {
       // this.catchTokenLocally();
        resolve(res);
      }, err => reject(err))
    });
  }


  /**
   * Fetch and catch token locally
   */
  catchTokenLocally(){
    firebase.auth().currentUser.getIdToken()
    .then(
        (token : string) => {
          this.token = token;
          localStorage.setItem("token",this.token) 
        })
  }
  

    /**
   * this is used to clear anything that needs to be removed
   */
  clear(): void {
    localStorage.clear();
  }


  /**
   * Check if user is logged in
   */
  isAuthenticated() : boolean{ 


    //const token = localStorage.getItem('token');
    // Check whether the token is expired and return
    // true or false
   // console.log(this.stichClient.auth.isLoggedIn);
  
        
    return this.stichClient.auth.isLoggedIn;
    /*var isAuth =  !this.jwtHelper.isTokenExpired(token);
    return isAuth;*/
  }


  /**
   * Log out user form the applcication.
   * //TO DO Need to clear token before
   */
  logout() {

    return new Promise<void>((resolve, reject)=>{
        this.stichClient.auth.logout()
        .then(() =>{
            //success
            resolve();
        }, () =>{
              //error
              reject();
        })
    })

    
    /*return new Promise<any>((resolve, reject) => {
      this._firebaseAuth.auth.signOut()
      .then(res => {
        this.clear();
        resolve(res);
      }, err => {
        console.log(err);
        reject(err);
      })
    })*/
      /*
      this._firebaseAuth.auth.signOut()
      .then((res) => this.router.navigate(['/']));*/
      

    }


    /**
     * Get Token for firebase user
     * These is a danger for token expire. Need to handle error for token expire
     */
    getToken(){
      this.catchTokenLocally();
      return this.token;
    }

/**
 * Login User using facebook
 */
  /*  loginUsingFacebook(){
      return new Promise<any>((resolve, reject) => {
        let provider = new firebase.auth.FacebookAuthProvider();
        this._firebaseAuth.auth
        .signInWithPopup(provider)
        .then(res => {
         // this.catchTokenLocally();
          resolve(res);
        }, err => {
          reject(err);
        })
      })
    }*/


    loginUsingFacebook(){
    
      return new Promise<any>((resolve, reject) => {

        const credential = new FacebookRedirectCredential();
        this.stichClient.auth.loginWithRedirect(credential);

        if (this.stichClient.auth.hasRedirectResult()) {
          this.stichClient.auth.handleRedirectResult().then(res => {
            // this.catchTokenLocally();
             resolve(res);
           }, err => {
             reject(err);
           });
        }
      });

      
      
    }




/**
 * Login Using Google
 */
  /*  loginUsingGoogle(){
      return new Promise<any>((resolve, reject) => {
        let provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('profile');
        provider.addScope('email');
        this._firebaseAuth.auth
        .signInWithPopup(provider)
        .then(res => {
          this.catchTokenLocally();
          resolve(res);
        }, err => {
          reject(err);
        })
      })
    }*/

    loginUsingGoogle(){
      return new Promise<any>((resolve, reject) => {

        const credential = new GoogleRedirectCredential();
        this.stichClient.auth.loginWithRedirect(credential);


        if (this.stichClient.auth.hasRedirectResult()) {
          this.stichClient.auth.handleRedirectResult().then(res => {
            // this.catchTokenLocally();
             resolve(res);
           }, err => {
             reject(err);
           });
        }
      });
    }

 



    /**
     * Is User email is verified
     */
    isUserEmailVerified() : boolean {
        return this.stichClient.auth.isUserEmailVerified;
        //return firebase.auth().currentUser.emailVerified;
    }

    /**
     * Send Verification Email to user 
     */
    sendEmailVerification(){
      return new Promise<any>((resolve, reject) => {
        this._firebaseAuth.auth.currentUser
        .sendEmailVerification()
        .then(res => {
          console.log(res);
          resolve(res);
        }, err => {
          console.log(err);
          reject(err);
        })
      })     
    }




  resendConfirmationURL(value){
    const emailPassClient = Stitch.defaultAppClient.auth
  .getProviderClient(UserPasswordAuthProviderClient.factory);

return emailPassClient.resendConfirmationEmail(value)
.then(res => {
  // this.catchTokenLocally();
   console.log("Done"+res);
 }, err => {
   console.log("Error"+err);
 });
  }

}

